import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { getLanguageFromDomain } from './detectLocale';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly translateService = inject(TranslateService);
  private readonly cookieService = inject(CookieService);

  public getLanguageToUse(): string {
    const domainLang = getLanguageFromDomain();
    let languageToUse = domainLang || 'pl';

    if (domainLang === 'pl') {
      const languageFromCookie = this.cookieService.get('ef-locale');

      if (languageFromCookie === 'ua') {
        return 'uk';
      }

      languageToUse = languageFromCookie || domainLang || 'pl';
    }

    return languageToUse;
  }

  public initializeLanguage(): void {
    const languageToUse = this.getLanguageToUse();
    this.translateService.use(languageToUse);
  }
}
